import { formatStorageSize } from '../../SummaryWrapper/inventorySummaryHelpers';
import { calcModernizationSavingsFromApi } from './osModernizationHelpers';
import { getGiBfromMiB } from '../../../lib/helpers';
import { getStorageCriteria } from '../../../pages/Discovery/helpers';
import { formatCount, formatDecimal } from '../../../lib/helpers';

// --- Modernization Savings ---

export const YEAR_OPTIONS = ['1yr', '2yr', '3yr'];

export const parseModernizationSavingsResponse = ({ summaryData, osPricingData, queryState, isPricingLoading, isPricingError }) => ({
    osPricingData,
    summaryData,
    isLoading: queryState?.isLoading || isPricingLoading,
    isError: queryState?.isError || isPricingError,
});

export const modernizationSavingsCardValues = ({ osPricingData, summaryData, isLoading, isError }) => ({
    title: 'Modernization Savings',
    segmentedOptions: YEAR_OPTIONS,
    modernizationSavingsFetch: (yearIndex) => calcModernizationSavingsFromApi(osPricingData, summaryData, yearIndex),
    queryState: { isLoading, isError },
});

// --- Potential Savings ---

export const parsePotentialSavingsResponse = ({ summaryData }) => ({
    potentialCPUSavings: summaryData?.total_unused_cpu ?? 0,
    potentialRAMSavings: formatStorageSize(
        summaryData?.total_unused_ram ? Math.floor(getGiBfromMiB(summaryData.total_unused_ram)) : 0,
    ),
    storageSavings: formatStorageSize(
        summaryData?.total_unused_storage ? Math.floor(getGiBfromMiB(summaryData.total_unused_storage)) : 0,
    ),
});

export const potentialSavingsCardValues = ({ potentialCPUSavings, potentialRAMSavings, storageSavings }) => ({
    title: 'Potential Savings',
    details: [
        { mainLabel: 'CPU', mainValue: `${formatCount(potentialCPUSavings)} vCPUs` },
        { mainLabel: 'RAM', mainValue: `${formatDecimal(potentialRAMSavings.value)} ${potentialRAMSavings.unit}` },
        { mainLabel: 'Storage', mainValue: `${formatDecimal(storageSavings.value)} ${storageSavings.unit}` },
    ],
});

// --- Top Ten Opportunities ---

const formatStorage = (gib) => {
    const { value, unit } = formatStorageSize(gib);
    return { value: formatDecimal(value), unit };
};

const parseTopTenItem = (item) => {
    const { cpu, cpu_count, ram, ram_size, storage, storage_size } = item.cost_savings;
    return {
        text: item.name,
        cpu: cpu > 0 && cpu_count ? cpu_count : null,
        cpuCriteria: item.cpu_utilization,
        ram: ram > 0 && ram_size ? formatStorage(getGiBfromMiB(ram_size)) : null,
        ramCriteria: item.ram_utilization,
        storage: storage > 0 && storage_size ? formatStorage(getGiBfromMiB(storage_size)) : null,
        storageCriteria: getStorageCriteria(item.storage_disks, item.storage_disks_used, item.storage_utilization),
    };
};

export const parseTopTenOpportunitiesResponse = ({ summaryData }) => ({
    topTenSavings: summaryData?.top_ten_savings ?? [],
});

export const topTenOpportunitiesCardValues = ({ topTenSavings }) => ({
    title: 'Top 10 Opportunities',
    details: topTenSavings.map(parseTopTenItem),
});
